import { Link } from "react-router-dom";
import { META, FRAMING } from "../../data/reportContent";

export const ExecSummaryHero = () => (
  <header className="report-hero" data-testid="execsummary-hero">
    <span className="report-kicker">{META.edition} · {META.date}</span>
    <div className="report-hero-rule" />
    <h1 data-testid="execsummary-title">{META.title}</h1>
    <p className="subtitle" data-testid="execsummary-subtitle">Executive Summary</p>
    <p className="framing" data-testid="execsummary-framing">{FRAMING}</p>
    <div className="report-hero-meta">
      <span>Executive Summary</span>
      <span>Prepared for trustees, staff, volunteers, community partners and funders</span>
    </div>
    <Link className="report-hero-back-link" to="/report" data-testid="execsummary-fullreport-link">
      Read the full report →
    </Link>
  </header>
);
